import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from '@guryou/colors';
import { WidgetContext } from './WidgetContext';

const WidgetContactForm = ({ margin = 'normal' }) => {
  const { t } = useTranslation();
  const { askFirstname, askLastname, askPhone, user, fontF, fontS } = useContext(WidgetContext);

  let emailFieldSizes = { xs: 12, md: 6, lg: 3 };
  if (!askFirstname && !askLastname && !askPhone) {
    emailFieldSizes = { xs: 12, md: 6, lg: 6 };
  }

  return (
    <div className="grid gap-4 mb-4 grid-cols-2 mt-6">
      <input
        type="text"
        placeholder={t('GENERAL.email') + ', ' + t('GENERAL.necessary')}
        name="email"
        class={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[${colors.mandy}] focus:border-[${colors.mandy}] block w-full p-2.5`}
        value={user ? user.email : null}
        required={true}
      />
      <input
        type="text"
        placeholder={askPhone ? t('GENERAL.phone') + ', ' + t('GENERAL.necessary') : t('GENERAL.phone')}
        name="phone"
        class={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[${colors.mandy}] focus:border-[${colors.mandy}] block w-full p-2.5`}
        value={user ? user.phone : null}
        required={askPhone}
      />
      <input
        type="text"
        placeholder={askFirstname ? t('GENERAL.name') + ', ' + t('GENERAL.necessary') : t('GENERAL.name')}
        name="firstname"
        class={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[${colors.mandy}] focus:border-[${colors.mandy}] block w-full p-2.5`}
        value={user ? user.firstname : null}
        required={askFirstname}
      />
      <input
        type="text"
        placeholder={askLastname ? t('GENERAL.surname') + ', ' + t('GENERAL.necessary') : t('GENERAL.surname')}
        name="lastname"
        class={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-[${colors.mandy}] focus:border-[${colors.mandy}] block w-full p-2.5`}
        value={user ? user.lastname : null}
        required={askLastname}
      />
    </div>
  );
};

export default WidgetContactForm;
